
class Cartdiscount extends HTMLElement {
  constructor() {
    super();

    this.coupon_button = this.querySelector('.cart-trigger');
    this.cart_content = this.querySelector('.cart-content');
    this.cartDrawerCheckoutButton = document.querySelector('#CartDrawer-Checkout'); 
    this.submit_button = this.querySelector('.cart-btn');
    this.discount_value = this.querySelector('input');
    
    this.active = false;
    
    this.init();
  }
  
  init(){
    this.coupon_button.addEventListener('click', (event) => {
      event.preventDefault();
      if(!this.active){ this.activeState(); this.active = true; }else{ this.hideState(); this.active = false; }
    });
    this.submit_button.addEventListener('click', (event) => {
      event.preventDefault();
      this.submit_button.textContent = "Loading...";
      this.fetchCode(this.discount_value.value);
    })
  }

  fetchCode(value) {
    this.cartDrawerCheckoutButton.disabled = true;
    fetch(`/discount/${value}`).then(async (response) => {

      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer', 'discount-code'];
  
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
  
            if (targetElement && sourceElement) {
              if (selector === 'discount-code') {
                sourceElement.classList.add('ajax-class-loaded');
              }
              targetElement.replaceWith(sourceElement);
            }
          }
          this.getDiscountMessage(value);
          
          setTimeout(function() {
            const discountCodeElement = document.querySelector('discount-code'); 
            if (discountCodeElement && discountCodeElement.classList.contains('ajax-class-loaded')) {
              discountCodeElement.classList.remove('ajax-class-loaded');
            }
          }, 5000);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.cartDrawerCheckoutButton.disabled = false;
        });
    });
  }

  getDiscountMessage(code) {
    let error_container = document.querySelector('.no-manual-discount');
    if(error_container != null){
      let message = window.ferg_discount_error_msg.find(d => d.discount === "default").message;  // Set default message
  
      window.ferg_discount_error_msg.forEach(discountObj => {
          if (discountObj.discount === code) {
              message = discountObj.message;
          }
      });
      error_container.innerHTML = message;
      
      return message;
    }
  }

  activeState(){
    this.cart_content.classList.add('active');
    this.coupon_button.classList.add('active');
  }

  hideState(){
    this.cart_content.classList.remove('active');
    this.coupon_button.classList.remove('active');
    this.discount_value.value = '';
  }
}

customElements.define('discount-code', Cartdiscount);


// cart-checkbox-products.js
class CartCheckboxProducts extends HTMLElement {
  constructor() {
    super();

    this.checkbox = this.querySelector('input[type="checkbox"]'); // Declare as a class property
    this.isLoading = false; // Add a flag to track if a request is in progress
    this.cartDrawerCheckoutButton = document.querySelector('#CartDrawer-Checkout'); // Get the CartDrawer-Checkout button
    this.init();
  }

  init() {
    this.checkbox.addEventListener('change', (event) => {
      if (this.isLoading) return; // If a request is in progress, do nothing
      let id = event.target.id;
      if (event.target.checked) {
        this.addProduct(id);
      } else {
        this.removeProduct(id);
      }
    });

  }

  cartCheckContent(data){
    console.log(data);
  }

  addProduct(variantId) {
    this.isLoading = true; // Set the flag to true when a request starts
    this.cartDrawerCheckoutButton.disabled = true; // Disable the CartDrawer-Checkout button
    let formData = {
      'items': [{
        'id': variantId,
        'quantity': 1
      }]
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      } else {
        return response.json();
      }
    })
    .then(data => {
      this.onCartUpdate();
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally(() => {
      this.isLoading = false; // Set the flag to false when the request is complete
      this.cartDrawerCheckoutButton.disabled = false; // Enable the CartDrawer-Checkout button
    });
  }

  removeProduct(variantId) {
    this.isLoading = true; // Set the flag to true when a request starts
    this.cartDrawerCheckoutButton.disabled = true; // Disable the CartDrawer-Checkout button
    let data = {
      "id" : variantId,
      "quantity" : 0
    }
    
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      } else {
        return response.json();
      }
    })
    .then(data => {
      if(data.item_count == 0){
        document.querySelector('cart-drawer').classList.add('is-empty')
      }
      this.onCartUpdate();
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally(() => {
      this.isLoading = false; // Set the flag to false when the request is complete
      this.cartDrawerCheckoutButton.disabled = false; // Enable the CartDrawer-Checkout button
    });
  }

  onCartUpdate() {
    const cartOldValue = document.querySelector(".cart-drawer__footer").dataset.oldPrice;

      fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const cartDrawerContent = html.querySelector('.cart-drawer');
        const targetCartDrawer = document.querySelector('.cart-drawer');
        if (cartDrawerContent && targetCartDrawer) {
          targetCartDrawer.innerHTML = cartDrawerContent.innerHTML;
        }
        this.FreeProductCheck(cartOldValue);
      })
      .catch((e) => {
        console.error(e);
      })
  }

    FreeProductCheck(oldCart){    
    var cartContents = fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(data => { 
      this.AddFreeProduct(data);
      this.CartConfetti(oldCart, data.total_price);
    });
  }

  CartConfetti(oldCart, newCart) {
    const recentCart = parseFloat(oldCart);
    const currentCart = parseFloat(newCart);
    const thresholdElement = document.querySelector('.shipping-progress-cont');
    if(thresholdElement){
      const thresholds = {
        threshold1: parseFloat(thresholdElement.getAttribute('data-threshold-1')),
        threshold2: parseFloat(thresholdElement.getAttribute('data-threshold-2')),
        threshold3: parseFloat(thresholdElement.getAttribute('data-threshold-3')),
      };
    
      for (const threshold in thresholds) {
        if (recentCart < thresholds[threshold] && currentCart >= thresholds[threshold]) {
          confetti({ particleCount: 120, spread: 80, origin: { x: 1, y: 0.4 } });
          break; // Stop checking other thresholds if confetti is triggered
        }
      }
    }
  }

  AddFreeProduct(cart){
    let progress_cont = document.querySelector(".shipping-progress-cont");
    let progress_free_prouct = progress_cont.dataset.freeProduct;
    let progress_free_theshold = progress_cont.dataset.thresholdPrice;
    let cart_total = cart.total_price;
    this.cartDrawerCheckoutButton = document.querySelector('#CartDrawer-Checkout'); 

    if (progress_free_prouct !== null && progress_free_prouct !== undefined) {
      let free_product = parseInt(progress_free_prouct);
      let free_on_cart = false;
      if(cart_total >= progress_free_theshold){
        
        cart.items.forEach(function(item){
          if(item.id == free_product){
            free_on_cart = true;
          }
        });
        if(free_on_cart == false){
          this.cartDrawerCheckoutButton.disabled = true;
          
          let formData = {
           'items': [{
            'id': free_product,
            'quantity': 1
            }]
          };
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
          .then(response => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            } else {
              return response.json();
            }
          })
          .then(data => {
            this.onCartUpdate();
          })
          .catch((error) => {
            console.error('Error:', error);
          })
          .finally(() => {
            this.cartDrawerCheckoutButton.disabled = false;
            confetti({ particleCount: 120, spread: 80, origin: { x: 1, y: 0.4 } });
          });
        }
      }else{
        let free_product_line;

        cart.items.forEach(function(item){
            if(item.id == free_product){
                free_on_cart = true;
                free_product_line = item.key;
            }
        });

        if(free_on_cart){
            this.cartDrawerCheckoutButton.disabled = true;
          
            let data = {
                "id" : free_product_line,
                "quantity" : 0
            }
          
            fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
          })
          .then(response => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            } else {
              return response.json();
            }
          })
          .then(data => {
            console.log(data);
            if(data.total_price == 0){
              document.querySelector('cart-drawer').classList.add('is-empty');
              
              fetch(`${routes.cart_url}?section_id=cart-drawer`)
              .then((response) => response.text())
              .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                const cartDrawerContent = html.querySelector('.cart-drawer');
                const targetCartDrawer = document.querySelector('.cart-drawer');
                if (cartDrawerContent && targetCartDrawer) {
                  targetCartDrawer.innerHTML = cartDrawerContent.innerHTML;
                }
              })
              .catch((e) => {
                console.error(e);
              })
            }else{
              this.onCartUpdate();
            }
          })
          .catch((error) => {
            console.error('Error:', error);
          })
          .finally(() => {
            this.cartDrawerCheckoutButton.disabled = false;
          });
        }
      }
    }
  }
}

customElements.define('cart-checkbox-products', CartCheckboxProducts);

class ShopifyCartListener {
  constructor() {
    this.subscribeToCartUpdates();
  }

  subscribeToCartUpdates() {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if(event.source == "product-form"){
        if(window.carting_checkbox_checked == false){
          this.addCheckboxProducts();
          window.carting_checkbox_checked = true;
        }
        
      }
      this.onCartUpdate(event);
    });
  }

  onCartUpdate(event) {
    this.fetchCartData();
    this.getCheckedAdditionalProducts();
  }

  fetchCartData() {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then((response) => response.json())
      .then((data) => {
        this.handleCartData(data);
      })
      .catch((error) => {
        console.error("Error fetching cart data:", error);
      });
  }

  handleCartData(cartData) {

    let item_count = cartData.item_count;
    let checkbox_count = this.getCheckedAdditionalProducts();
    if(item_count == checkbox_count){
      this.clearCart();
    }
  }

  clearCart(callback) {
    fetch(`${window.Shopify.routes.root}cart/clear.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        this.finalCartUpdate();
      })
      .catch((error) => {
        console.error("Error clearing cart:", error);
      });
  }

  getCheckedAdditionalProducts() {
    const checkedElements = document.querySelectorAll('[name="additional_product"]:checked');
    return checkedElements.length;
  }

  addCheckboxProducts(){
    let formData = {
      'items': []
    };
    console.log("has checkbox products");
    window.checkbox_products.forEach(product => {
      if (product.auto_add && !product.in_cart) {
        formData.items.push({
          id: product.variant,
          quantity: 1
        });
      }
    });
    
    if (formData.items.length > 0) {
      
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        } else {
          return response.json();
        }
      })
      .then(data => {
        this.AddCartUpdate();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }
  }

  AddCartUpdate() {
    
    fetch(`${routes.cart_url}?section_id=cart-drawer`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const cartDrawerContent = html.querySelector('.cart-drawer');
      const targetCartDrawer = document.querySelector('.cart-drawer');
      if (cartDrawerContent && targetCartDrawer) {
        targetCartDrawer.innerHTML = cartDrawerContent.innerHTML;
      }
    })
    .catch((e) => {
      console.error(e);
    })
  }

  finalCartUpdate() {
    document.querySelector('cart-drawer').classList.add('is-empty');
              
    fetch(`${routes.cart_url}?section_id=cart-drawer`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const cartDrawerContent = html.querySelector('.cart-drawer');
      const targetCartDrawer = document.querySelector('.cart-drawer');
      if (cartDrawerContent && targetCartDrawer) {
        targetCartDrawer.innerHTML = cartDrawerContent.innerHTML;
      }
    })
    .catch((e) => {
      console.error(e);
    })
  }
}

const cartListener = new ShopifyCartListener();
